var $ = require('jquery'); 

var ajaxHandler = { 
    triggerAjaxCall: function _triggerAjaxCall(_self, ajaxurl, data){
    data.sessionToken = _self.getSessionToken();    
    data.sourceURI = _self.getSourceURI();    
    data.variation = _self.getVariation();    
    data.context.success = true;
    _self.makeAjaxCall({
        url: ajaxurl,
        method: "POST",
        data: JSON.stringify(data),
        success: function (data) {
            var response = data.component.data;
	    //if response is available then set new validateToken in hidden input nad update the page url with the new validateToken and resetToken
            if(response.validateToken) {
		var validateToken = response.validateToken;
		var queryParam = "resetToken=" + $('#reset-token').val() + "&validateToken=" + validateToken;
		$('#validateToken').val(validateToken);
		var pageurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + queryParam;
    		window.history.pushState({path:pageurl},'',pageurl);
    	     }
	else if($('#mobilePhoneOtpVerificationForm').length)
           {
              $('#otpTransactionId').val(response.hiddenInputs[1].value);
              $('#phoneNumber').val(response.hiddenInputs[0].value);

           }
	  else {
            if(response.isError && (response.errorMessageKeys[0] || response.errorMessagesList[0])) {
                var errorMsgContainer = $('.js-custom-message-box, .tile-message-box');
                errorMsgContainer.remove();
                var errorMsg = '<div class="tile-message-box l-enroll-border-none  message-box m-message-box m-message-box-error t-font-s t-error-message l-margin-double-bottom js-custom-message-box" tabindex="0" role="alert"><p class="message-title t-font-m t-font-weight-semibold l-margin-none">' +response.messageTitle+ '</p>';
                for(var i in response.errorMessageKeys){
                  if(i > 0) {
                      errorMsg = errorMsg + '<br>';
                  }
                errorMsg = errorMsg + '<span class="message-items t-message">' +response[response.errorMessageKeys[i]]+ '</span>'
                }
                for(var i in response.errorMessagesList) {
                    if(i > 0) {
                      errorMsg = errorMsg + '<br>';
                    }
                    errorMsg = errorMsg + '<span class="message-items t-message">' +response.errorMessagesList[i]+ '</span>'
                }
              errorMsg = errorMsg + '</div>'
              $('.form-sub-section .two-col-sub-section').prepend(errorMsg);
              $('.js-send-verification-code-btn').removeClass("is-disabled t-cursor-default").prop("disabled", false);
              $('#mobile-phone').addClass('is-error');
        }
            else{
              var sendVerificationBtn = $('.js-send-verification-code-btn');
                $('.js-custom-message-box, .tile-message-box').addClass('is-hidden');
                $('#mobile-phone, #verification-code, #field-email, #field-password, #field-password-confirmation').removeClass('is-error');
                $('span.t-icon.t-icon-right.t-icon-cross').remove();  
                sendVerificationBtn.addClass("is-disabled t-cursor-default").prop("disabled", true);
                $('#field-email, #field-password, #field-password-confirmation, #field-remember-me, .js-field-one-time-code').removeClass("is-disabled t-cursor-default t-bg-standard-30").prop("disabled", false);
                $('.js-btn-submit').removeClass("t-bg-standard-100 t-border").prop("disabled", false);
                $('.js-resend-code').removeClass("l-resend-code");	
                $('.js-otp-transactionId').val(response.otpTransactionid);
		$('.after-otp-sent').addClass('l-display-inline').removeClass('is-hidden');
                $('.before-otp-sent').removeClass('l-display-inline').addClass('is-hidden');
            }
	    }
        },
	error: function(jqXHR, textStatus, errorThrown) {
            return textStatus;
        }
    });
  }
} 
module.exports = ajaxHandler;
